/**
 * US States array - shared utility
 * Extracted from JoinTheTeamDialog.tsx for reuse across components
 *
 * Constitution Principle V: State Isolation (NON-NEGOTIABLE)
 * - Uses exact string values, no fuzzy matching
 * - "Kansas" must never resolve to "Arkansas"
 */

export const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
] as const;

/**
 * Type for US state values
 */
export type USState = (typeof US_STATES)[number];

/**
 * Validate if a string is a valid US state (exact match only)
 */
export function isValidUSState(value: string): value is USState {
  return US_STATES.includes(value as USState);
}
